// @ts-check
import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import TypographyOverflow from '@liquidweb-dev/undercurrent/TypographyOverflow';

/**
 * @typedef KeySpecProps
 * @property {React.ReactNode} [icon]
 * @property {React.ReactNode} label
 * @property {React.ReactNode} value
 */

/** @param {import('@liquidweb-dev/undercurrent/Stack').StackProps & KeySpecProps} props */
const KeySpec = ({ icon, label, value, ...rest }) => (
	<Stack
		{...rest}
		sx={[
			{
				gap: 50,
			},
			...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
		]}
	>
		<Stack
			direction="row"
			sx={{
				justifyContent: 'space-between',
				gap: 100,
			}}
		>
			<TypographyOverflow
				variant="label-md"
				sx={{ color: (theme) => theme.vars.palette.uc.text.weak }}
			>
				{label}
			</TypographyOverflow>
		</Stack>
		<Stack
			direction="row"
			sx={{
				gap: 50,
				alignItems: 'center',
				py: 50,
			}}
		>
			{icon}
			{typeof value === 'string' ? (
				<TypographyOverflow variant="label-md">{value}</TypographyOverflow>
			) : (
				value
			)}
		</Stack>
	</Stack>
);

export default KeySpec;
